<template>
  <div class="col-10 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label"> Razon social (*) </label>

                <el-input
                  v-model="formData.businessName"
                  v-validate="modelValidations.businessName"
                  name="businessName"
                  placeholder="Razon Social"
                >
                </el-input>

                <small v-show="businessName.invalid" class="text-danger">
                  {{ getError('businessName') }}
                </small>
              </div>

              <div class="form-group">
                <label class="control-label"> CUIT </label>

                <el-input v-model="formData.cuit" v-validate="modelValidations.cuit" name="cuit" placeholder="CUIT">
                </el-input>

                <small v-show="cuit.invalid" class="text-danger">
                  {{ getError('cuit') }}
                </small>
              </div>
            </div>

            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label"> Dirección (*) </label>

                <el-input
                  v-model="formData.address"
                  v-validate="modelValidations.address"
                  name="address"
                  placeholder="Dirección"
                >
                </el-input>

                <small v-show="address.invalid" class="text-danger">
                  {{ getError('address') }}
                </small>
              </div>

              <div class="form-group">
                <label class="control-label"> Teléfono </label>

                <el-input
                  v-model="formData.phone"
                  v-validate="modelValidations.phone"
                  name="phone"
                  placeholder="Teléfono"
                >
                </el-input>

                <small v-show="phone.invalid" class="text-danger">
                  {{ getError('phone') }}
                </small>
              </div>
            </div>

            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label"> Email </label>

                <el-input v-model="formData.email" v-validate="modelValidations.email" name="email" placeholder="Email">
                </el-input>

                <small v-show="email.invalid" class="text-danger">
                  {{ getError('email') }}
                </small>
              </div>
            </div>

            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label">Distribuidor (*)</label>

                <el-select
                  v-model="formData.distributor"
                  v-validate="modelValidations.distributor"
                  autocomplete="off"
                  filterable
                  name="distributor"
                  placeholder="Seleccione Distribuidor"
                >
                  <el-option
                    v-for="option in distributorsOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="distributor.invalid" class="text-danger">
                  {{ getError('distributor') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="row justify-content-center">
                <div class="col-sm-5">
                  <div class="form-group">
                    <label class="control-label"> Provincia (*) </label>

                    <el-select
                      v-model="formData.province"
                      v-validate="modelValidations.province"
                      autocomplete="off"
                      filterable
                      name="province"
                      placeholder="Provincia"
                      @change="clearCity"
                    >
                      <el-option
                        v-for="option in provincesOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      >
                      </el-option>
                    </el-select>

                    <small v-show="province.invalid" class="text-danger">
                      {{ getError('province') }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-5">
                  <div class="form-group">
                    <label class="control-label d-block"> Localidad (*) </label>

                    <el-autocomplete
                      v-model="formData.cityName"
                      v-validate="modelValidations.city"
                      :disabled="!formData.province"
                      name="city"
                      class="w-100"
                      placeholder="Localidad"
                      :fetch-suggestions="querySearchAsync"
                      @select="selectCity"
                    >
                    </el-autocomplete>

                    <small v-show="city.invalid" class="text-danger d-block">
                      {{ getError('city') }}
                    </small>

                    <small v-show="searchError !== ''" class="text-danger d-block">
                      {{ searchError }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <h4 class="h4 mt-3 mb-4 text-center">Datos de siembra</h4>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Hectáreas propias </label>
                <el-input v-model="formData.ownedHectares" name="ownedHectares"> </el-input>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Hectáreas arrendadas </label>
                <el-input v-model="formData.leasedHectares" name="leasedHectares"> </el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label class="control-label"> Hectáreas de maíz </label>
                <el-input v-model="formData.corn" name="corn"> </el-input>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label class="control-label"> Hectáreas maíz silero </label>
                <el-input v-model="formData.storageCorn" name="storageCorn"> </el-input>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label class="control-label"> Hectáreas alfalfa </label>
                <el-input v-model="formData.alfalfa" name="alfalfa"> </el-input>
              </div>
            </div>

            <server-error :server-errors="serverErrors"></server-error>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Autocomplete } from 'element-ui';
import cityProvinceOptionsMixin from '@/mixins/cityProvinceOptionsMixin';
import { mapFields } from 'vee-validate';
import ServerError from '../../../components/ServerError';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    ServerError,
  },

  mixins: [cityProvinceOptionsMixin],
  props: {
    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },

    title: {
      type: String,
      default: 'Agregar nuevo productor',
    },

    producer: {
      type: Object,
      default: () => {
        return {
          businessName: null,
          cuit: null,
          distributor: null,
          city: null,
          province: null,
          address: '',
          email: '',
          phone: '',
          ownedHectares: null,
          leasedHectares: null,
          corn: null,
          storageCorn: null,
          alfalfa: null,
        };
      },
    },
  },

  data() {
    return {
      validated: false,
      distributors: [],
      formData: {
        distributor: this.producer.distributor ? this.producer.distributor.id : null,
        businessName: this.producer.businessName,
        cuit: this.producer.cuit,
        email: this.producer.email,
        province: null,
        city: null,
        cityName: null,
        address: this.producer.address,
        phone: this.producer.phone,
        ownedHectares: this.producer.ownedHectares,
        leasedHectares: this.producer.leasedHectares,
        corn: this.producer.corn,
        storageCorn: this.producer.storageCorn,
        alfalfa: this.producer.alfalfa,
      },

      modelValidations: {
        businessName: {
          required: true,
          min: 5,
        },

        cuit: {
          numeric: true,
          length: 11,
        },

        email: {
          email: true,
        },

        phone: {
          numeric: true,
          min: 10,
        },

        address: {
          required: true,
        },

        city: {
          required: true,
        },

        province: {
          required: true,
        },

        distributor: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields([
      'businessName',
      'cuit',
      'province',
      'city',
      'address',
      'email',
      'phone',
      'distributor',
      'ownedHectares',
      'leasedHectares',
      'corn',
      'storageCorn',
      'alfalfa',
    ]),

    distributorsOptions() {
      return this.$selectOptions(this.distributors, { sort: true });
    },
  },

  created() {
    this.fetchDistributors();
  },

  mounted() {
    if (this.producer.city) {
      this.defaultCity = this.producer.city.id;
      this.defaultCityName = this.producer.city.name;
      this.defaultProvince = this.producer.city.province.id;
    }
  },

  methods: {
    fetchDistributors() {
      this.$services
        .resource('distributors')
        .get({ for_select: true })
        .then((res) => res.data.data)
        .then((data) => {
          this.distributors = data.distributors;
          if (this.distributors.length === 1) {
            this.formData.distributor = this.distributors[0];
          }
        });
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
